export const hybridspaceErrorAccessDeniedTitle = "Z8CSq";
export const hybridspaceErrorAccessDeniedSubtitle = "TmU$pb";
export const hybridspaceErrorAccessDeniedCallToAction = "maRZgb";
export const hybridspaceErrorAccessDeniedCallToActionHyperlinkText = "Dp4NEe";
export const hybridspaceErrorAccessDeniedSignOut = "ojnUYd";
export default {hybridspaceErrorAccessDeniedTitle,hybridspaceErrorAccessDeniedSubtitle,hybridspaceErrorAccessDeniedCallToAction,hybridspaceErrorAccessDeniedCallToActionHyperlinkText,hybridspaceErrorAccessDeniedSignOut};